export default __webpack_public_path__ + "static/378ac41ed0d6d716c2928dce91af21e3.jpg";